<template>
  <section>
    <ul class="filters-list">
      <li v-if="hasPermission('reports_tab', 'view')">
        <router-link
          :to="{
            name: 'NewReportCases',
            query: this.$route.query,
          }"
        >
          NEW REPORTS
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'AllCases',
            query: this.$route.query,
          }"
        >
          ALL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'ActiveCases',
            query: this.$route.query,
          }"
        >
          ACTIVE
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="hasPermission('cases', 'cases_filters_view')">
        <router-link
          :to="{
            name: 'PendingCases',
            query: this.$route.query,
          }"
        >
          PROCESSING
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'CompleteCases',
            query: this.$route.query,
          }"
        >
          FINALIZED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="hasPermission('cases', 'cases_filters_add_new')">
        <router-link
          :to="{
            name: 'ArchiveCase',
            query: this.$route.query,
          }"
        >
          ARCHIVED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link
          :to="{
            name: 'RejectedCases',
            query: this.$route.query,
          }"
        >
          REJECTED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <!-- <li v-if="hasPermission('cases', 'cases_filters_add')">
        <router-link
          :to="{
            name: 'PendingCasesList',
            query: this.$route.query,
          }"
        >
          PENDING
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li> -->
      <li v-if="hasPermission('cases', 'cases_filters_add')">
        <router-link
          :to="{
            name: 'EMRNotSend',
            query: this.$route.query,
          }"
        >
          EMR NOT SENT
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" />
          </span>
        </router-link>
      </li>
      <!-- <li
        v-if="hasPermission('cases_filters', 'view') && checkLab"
        v-loading="loading"
      >
        <router-link
          :to="{
            name: 'CriticalCases',
            query: this.$route.query,
          }"
        >
          CRITICAL

          {{
            this.getCriticalCounts
              ? "(" + (this.getCriticalCounts.count || 0) + ")"
              : "(" + "0" + ")"
          }}
        </router-link>
      </li>    
      <li>
        <router-link
          :to="{
            name: 'ReleasePending',
            query: this.$route.query,
          }"
        >
          REQUIRES ATTENTION
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li> -->
      <li v-if="!isBillingUser">
        <router-link
          :to="{
            name: 'ReplacedInsurance',
            query: this.$route.query,
          }"
        >
          REPLACED
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import { mapGetters } from "vuex";
export default {
  mixins: [UserPermissionsHelper],
  computed: {
    ...mapGetters("cases", ["getCriticalCounts"]),

    ...mapGetters("auth", ["getUserAllowedLabs", "getUserPrimaryLabId"]),
    checkLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && matchedLab.lab_code == "DLW-TX") {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  mounted() {
    if (this.checkLab) {
      this.fetchAllCriticalCasesCount();
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async fetchAllCriticalCasesCount() {
      try {
        this.loading = true;
        let params = {
          is_critical : true,
          is_resolved :false
        }
        await this.$store.dispatch("cases/fetchCriticalCasesCount",params);
        this.loading = false;
      } catch (err) {}
    },
  },
  watch: {
    $route() {
      this.fetchAllCriticalCasesCount();
    },
  },
};
</script>